var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;}")), /*#__PURE__*/React.createElement("polyline", {
    points: "5.731 22.52 3.96 22.875 0.5 5.597 13.712 2.951 14.707 7.918"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.855,
    y1: 7.366,
    x2: 11.972,
    y2: 6.942
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.294,
    y1: 9.8,
    x2: 12.412,
    y2: 9.376
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.489,
    y: 7.94,
    width: 2.943,
    height: 2.943,
    transform: "translate(-1.732 1.354) rotate(-11.325)"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "4.54 4.788 4.7 0.607 18.165 1.121 17.894 8.222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.538,
    y: 13.272,
    width: 14.962,
    height: 10.122,
    rx: 1.037
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.538,
    y1: 17.672,
    x2: 14.973,
    y2: 17.672
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.065,
    y1: 17.672,
    x2: 23.5,
    y2: 17.672
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.415,10.955h3.208a1.037,1.037,0,0,1,1.037,1.037v1.28a0,0,0,0,1,0,0H13.378a0,0,0,0,1,0,0v-1.28A1.037,1.037,0,0,1,14.415,10.955Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.973,
    y: 16.352,
    width: 2.092,
    height: 2.64,
    rx: 0.518
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.4634b017.svg";
export { ForwardRef as ReactComponent };